import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './dvr.stop-many.reducer';

export const stopManyDvrFeatureKey = 'stopManyDVRs';
export const featureSelector = createFeatureSelector<State>(stopManyDvrFeatureKey);

export const getStopManyDvrRecord = createSelector(
  featureSelector,
  (state: State): null => state.record
);

export const getStopManyDvrLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getStopManyDvrLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getStopManyDvrError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
